export default __webpack_public_path__ + "static/media/328.44c6a641.png";